import ListIcon from "@mui/icons-material/List";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { GET_SOP_HEADERS, GET_SOP_LEVEL_LOGS } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "../HomeHeader.css";
import moment from "moment-timezone";
import "./Table.css";
import DifferenceIcon from "@mui/icons-material/Difference";
import FullScreenDialog from "./FullScreenDialog";
import LoaderComponent from "../ConfigurePages/LoaderComponent/LoaderComponent";

export default function SopLevelTable(props) {
  const [count, setCount] = useState(1);
  const [loader, setloader] = useState(true);
  const [sopLevelData, setSopLevelData] = useState();
  const [totaldata, settotaldata] = useState();
  const [numberOfentries, setNumberOfentries] = useState(25);
  const [isListVisible, setListVisible] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [fixedheaderKey, sefixedheaderKey] = useState();
  const [StudyDataallHeaders, setStudyDataallHeaders] = useState();
  const [studyDataDefaultHeaders, setstudyDataDefaultHeaders] = useState();
  const [open, setOpen] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState(null);
  const handleOpen = (items) => {
    setCurrentItem(items);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (props.flagforfilterby) {
      setCount(1);
    }
  }, [props.flagforfilterby]);

  useEffect(() => {
    if (props.searchflag) {
      setCount(1);
    }
  }, [props.searchflag, props.searchInput]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_SOP_LEVEL_LOGS}?page=${
            props.searchflag || props.flagforfilterby ? 1 : count
          }&size=${numberOfentries}`,
          props.searchInput,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setSopLevelData(response.data.items);
        setTotalPages(response.data.pages);
        settotaldata(response.data.total);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    fetchData();
  }, [props.searchInput, count, numberOfentries]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `${GET_SOP_HEADERS}`,

          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        const data = [];
        const array =
          response &&
          response.data &&
          response.data.default_headers &&
          response.data.default_headers.map((item) => {
            data.push({
              key: item.response_header,
              value: item.display_header,
            });
          });
        // data.push({
        //   key: "Diff",
        //   value: "Diff",
        // });
        setstudyDataDefaultHeaders(data);

        const data2 = [];
        const array2 =
          response &&
          response.data &&
          response.data.all_headers &&
          response.data.all_headers.map((item) => {
            data2.push({
              key: item.response_header,
              value: item.display_header,
            });
          });
        // data2.push({
        //   key: "Diff",
        //   value: "Diff",
        // });
        setStudyDataallHeaders(data2);
        const keyname = [];
        for (let i = 0; i < response.data.default_headers.length; i++) {
          keyname.push(response.data.default_headers[i].response_header);
        }
        // keyname.push("Diff");
        sefixedheaderKey(keyname);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleList = () => {
    setListVisible(!isListVisible);
  };

  const handlePageChange = (page) => {
    props.setsearchflag(false);

    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };

  const handleCheckboxChange = (e, item) => {
    e.stopPropagation();
    setstudyDataDefaultHeaders((prevHeaders) => {
      const index = prevHeaders.findIndex((header) => header.key === item.key);

      if (index !== -1) {
        // Header is currently in the list, remove it
        return [
          ...prevHeaders.slice(0, index),
          ...prevHeaders.slice(index + 1),
        ];
      } else {
        // Header is not in the list, add it
        return [...prevHeaders, item];
      }
    });

    sefixedheaderKey((prevKeys) => {
      if (prevKeys.includes(item.key)) {
        // Key is currently in the list, remove it

        return prevKeys.filter((key) => key !== item.key);
      } else {
        // Key is not in the list, add it

        return [...prevKeys, item.key];
      }
    });
  };

  const handleoption = (e) => {
    if (totaldata >= e.target.value) {
      setNumberOfentries(e.target.value);
    } else {
      setNumberOfentries(totaldata);
    }
  };

  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setListVisible(false);
    }
  };

  const dateconversion = (timestampStr) => {
    if (!timestampStr.trim()) {
      return timestampStr;
    }
    return timestampStr;
  };

  return (
    <>
      <ListIcon
        style={{ marginLeft: "93vw" }}
        onClick={toggleList}
        ref={containerRef}
      />
      {isListVisible && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="your-list-styles"
          style={{
            left: "86vw",
            position: "absolute",
            backgroundColor: "#182423",
            color: "white",
            zIndex: 1,
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            width: "fit-content",
            minWidth: "200px",
          }}
        >
          <div>
            {StudyDataallHeaders &&
              StudyDataallHeaders.map((item) => {
                const isChecked = studyDataDefaultHeaders.some(
                  (data) => data.value === item.value
                );

                return (
                  <div key={item.key}>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => handleCheckboxChange(e, item)}
                    />{" "}
                    <span> {item.value}</span>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {loader ? (
        <div
          className="d-flex flex-column"
          style={{ width: "91.4vw", overflowX: "auto", marginLeft: "6rem" }}
        >
          <div>
            <div>
              <div className="table-main-inside">
                <table className="styled-table-home">
                  <thead>
                    <tr>
                      {/* <th>SR.No.</th> */}
                      {studyDataDefaultHeaders &&
                        studyDataDefaultHeaders.map((item) => (
                          <th>{item.value}</th>
                        ))}
                    </tr>
                  </thead>
                  {sopLevelData && sopLevelData.length > 0 ? (
                    <tbody>
                      {sopLevelData &&
                        sopLevelData.map((items, index) => (
                          <tr key={index} className="styled-table">
                            {/* <td>{index + 1 + (count - 1) * numberOfentries}</td> */}

                            {fixedheaderKey &&
                              fixedheaderKey.map((key) => (
                                <td className="word-break">
                                  {" "}
                                  {key === "created_on" ||
                                  key === "last_updated_at"
                                    ? dateconversion(items[key])
                                    : // : key == "Diff" ? (
                                      //   <DifferenceIcon
                                      //     sx={{
                                      //       cursor: "pointer",
                                      //       color: "#0cc4a0 !important",
                                      //     }}
                                      //     onClick={() => {
                                      //       handleOpen(items);
                                      //     }}
                                      //   />
                                      // )
                                      items[key]}
                                </td>
                              ))}
                          </tr>
                        ))}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center font-weight-bold">
                        No Records Found
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ margin: "10vw 48vw" }}
        >
          <div>
            <LoaderComponent />
          </div>
        </div>
      )}
      <FullScreenDialog
        open={open}
        handleClose={handleClose}
        currentItem={currentItem}
      />
      <div>
        {" "}
        {sopLevelData && sopLevelData.length > 0 ? (
          <div className="d-flex justify-content-between pb-5 mt-2">
            <div
              style={{
                color: "white",
                fontSize: "14px",
                marginLeft: "6rem",
              }}
            >
              <div>
                <span>Show </span>
                <select
                  className="entries-select"
                  onChange={(e) => handleoption(e)}
                  value={numberOfentries}
                >
                  {[25, 50, 75, 100].map((pageSize) => (
                    <option
                      key={pageSize}
                      value={pageSize}
                      style={{ color: "#82024" }}
                    >
                      {pageSize}
                    </option>
                  ))}
                </select>
                <span>Entries </span>
              </div>

              {`Showing ${numberOfentries * count - (numberOfentries - 1)} to ${
                numberOfentries * count > totaldata
                  ? totaldata
                  : numberOfentries * count
              } of ${totaldata} Entries`}
            </div>
            <div>
              {" "}
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={totalPages && totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={count && count - 1} //{entityList.number}
                onPageChange={(e) => handlePageChange(e.selected)}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
                previousLinkClassName="pagination-link"
                nextLinkClassName="pagination-link"
                breakLinkClassName="pagination-link"
                pageLinkClassName="pagination-link"
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
